 document.addEventListener('alpine:init', () => {
      Alpine.data('customProductForm', () => ({
        selectedValue: 'None',
        selectedPrice: '',
        selectedTitle: '',

        baseRegular: 0,
        baseSale: 0,
        baseSalep: 0,
  
        get shouldShow() {
         const selectEl = document.querySelector('.custom_slect');
          if (!selectEl) return true; // 如果不存在，则显示
          return this.selectedValue !== 'None';
        },
  
        init() {
          this.cacheBasePrices();
          this.refresh();
        },
  
        cacheBasePrices() {
            const parseUSD = str => Number(str.replace(/[^0-9.]/g, '') || 0);
          const regularEl = document.querySelector('.price__sale .price-item--regular');
       
          const saleEl = document.querySelector('.price__sale .price-item--sale') ;
  
          const onlyregularEl = document.querySelector('.price__regular .price-item.price-item--regular');
  
          if (regularEl) {
            // const baseRegStr = regularEl.textContent.replace(/[^0-9.]/g, '');
            this.baseRegular = parseUSD(regularEl?.textContent || '')
          }
  
          if (saleEl) {
            // const baseSaleStr = saleEl.textContent.replace(/[^0-9.]/g, '');
            this.baseSale = parseUSD(saleEl?.textContent || '')
          }
  
           if (onlyregularEl) {
            // const baseSaleStrp = onlyregularEl.textContent.replace(/[^0-9.]/g, '');
            this.baseSalep = parseUSD(onlyregularEl?.textContent || '')
          }
        },
  
        refresh() {
          this.$nextTick(() => {
            const select = document.querySelector('.custom_slect');
            if(select){
              this.selectedValue = select.value
            }else{
               const selectedRadio = document.querySelector('.custom_div_contain input:checked');
               this.selectedPrice = selectedRadio.getAttribute('data-price');
               this.selectedTitle = selectedRadio.getAttribute('data-title');
              
              const proPrice = parseFloat(selectedRadio.dataset.proprice.replace(/[^0-9.]/g, '')) || 0;
              const regularEl = document.querySelector('.price__sale .price-item--regular');
              const saleEl = document.querySelector('.price__sale .price-item--sale');
              const onlyregularEl = document.querySelector('.price__regular .price-item.price-item--regular');
              if (regularEl) regularEl.textContent = this.formatUSD(this.baseRegular + proPrice);
              if (saleEl) saleEl.textContent = this.formatUSD(this.baseSale + proPrice);
              if (onlyregularEl) onlyregularEl.textContent = this.formatUSD(this.baseSalep + proPrice);
              
            }

          });
        },
  
        resetPrices() {
          const regularEl = document.querySelector('.price__sale .price-item--regular');
          const saleEl = document.querySelector('.price__sale .price-item--sale') 
          const onlyregularEl = document.querySelector('.price__regular .price-item.price-item--regular');

          if (regularEl) {
            regularEl.textContent = this.formatUSD(this.baseRegular);
            // regularEl.textContent = `$${this.baseRegular.toFixed(2)} USD`;
          }
        
          if (saleEl) {
            saleEl.textContent = this.formatUSD(this.baseSale);
            // saleEl.textContent = `$${this.baseSale.toFixed(2)} USD`;
          }
           if (onlyregularEl) {
            onlyregularEl.textContent = this.formatUSD(this.baseSalep);
            // onlyregularEl.textContent = `$${this.baseSalep.toFixed(2)} USD`;
          }
        },
  
        updatePrice(event) {
          const target = event.target;
          this.selectedPrice = target.getAttribute('data-price') || '';
          this.selectedTitle = target.getAttribute('data-title') || '';

          const proPrice = parseFloat(target.dataset.proprice.replace(/[^0-9.]/g, '')) || 0;
        
          const regularEl = document.querySelector('.price__sale .price-item--regular');
          const saleEl = document.querySelector('.price__sale .price-item--sale');
          const onlyregularEl = document.querySelector('.price__regular .price-item.price-item--regular');

          if (regularEl) regularEl.textContent = this.formatUSD(this.baseRegular + proPrice);
          if (saleEl) saleEl.textContent = this.formatUSD(this.baseSale + proPrice);
          if (onlyregularEl) onlyregularEl.textContent = this.formatUSD(this.baseSalep + proPrice);

        },
        
        formatUSD(num) {
          return `$${num.toLocaleString(undefined, { minimumFractionDigits: 2 })} USD`;
        }
      }));
    });